import { render, staticRenderFns } from "./DocAcaoCancelar.vue?vue&type=template&id=65b3c787&scoped=true&lang=pug&"
import script from "./DocAcaoCancelar.vue?vue&type=script&lang=js&"
export * from "./DocAcaoCancelar.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoCancelar.vue?vue&type=style&index=0&id=65b3c787&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3c787",
  null
  
)

export default component.exports